<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-20 20:54:48
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2019-07-10 03:25:12
 * @Description: file content
 本页面是为了显示小程序需要在网页上展示图片。
 传入的URL参数，根据type不同也有所不同。

 1、type=get_hdk_qrcode
 获取很多客二维码，并展示
 其他参数：
 title：本网页的标题
 appid：公众号appid
 url：文章的url
 fist_push_text：扫码关注之后首推的文字
 intro：扫码说明 可选

 2、type=direct_show
 title：本网页的标题
 直接显示传入的图片链接
 url：图片链接
intro：扫码说明 可选

 -->
<template>
  <div class="container">
    <div class="img_frame">
      <img class="qrcode" :src="imgUrl" alt />
    </div>
    <div class="intro_txt">{{introTxt}}</div>
  </div>
</template>

<script>
import * as comreq from "@/utils/comreq";
import util from "@/utils/utils";
export default {
  components: {},
  props: {},
  data() {
    return {
      imgUrl: "",
      introTxt: ""
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    /**
     * https://xxx.ttrushi.com/qc-webapp/wxapi.do?j={"action":"/global/Qrcode/limitWxQRCodeWithCallbackUrl",
     * requestParam:{"appid":"xxxxx", "callbackurl":"",
     * "respText":"您的名片文章《文章标题》已生成，<a href=\"%s\">点击分享到朋友圈</a >","qrkey":"hdk"}}
     */
    // https://henduoke.quanc.com.cn/h5/hdk/comm_show_img?appid=XXXX&url=XXXX
    const that = this;
    if (
      util.queryCheck(
        {
          type: "类型",
          title: "网页标题"
        },
        that.$route.query
      )
    ) {
      document.title = decodeURIComponent(that.$route.query.title);
      if (that.$route.query.intro) {
        this.introTxt = decodeURIComponent(that.$route.query.intro);
      }
      if (that.$route.query.type == "get_hdk_qrcode") {
        if (
          util.queryCheck(
            {
              appid: "公众号appid",
              url: "文章链接",
              fist_push_text: "扫码首推文字"
            },
            that.$route.query
          )
        ) {
          comreq
            .limitWxQRCodeWithCallbackUrl(
              that.$route.query.appid,
              encodeURIComponent(that.$route.query.fist_push_text)
            )
            .then(function(data) {
              that.imgUrl = data;
            });
        }
      } else if (that.$route.query.type == "direct_show") {
        if (
          util.queryCheck(
            {
              url: "图片链接"
            },
            that.$route.query
          )
        ) {
          that.imgUrl = that.$route.query.url;
        }
      }
    }
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: url("https://assets.rurushishi.com/yq-rs-make/hdk/comm_show_img/bg.png");
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.img_frame {
  width: 250px;
  height: 220px;
  background: url("https://assets.rurushishi.com/yq-rs-make/hdk/comm_show_img/frame.png");
  background-size: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -50px;
}
.img_frame .qrcode {
  width: 180px;
  height: 180px;
  margin-top: 10px;
}

.intro_txt {
  width: 250px;
  padding-top: 20px;
  line-height: 30px;
  font-size: 17px;
  color: #333333;
  text-align: center;
}
</style>